import React from 'react';
import Template from './template';
import { ServiceInterviewNoApprove } from 'components';
import { useServiceStatus } from 'hooks';
import moment from 'moment';

function ServiceInterviewNoApproveView(): React.ReactElement {
  const { serviceState, serviceType } = useServiceStatus();
  const { serviceStatusHistoryList } = serviceState;
  /**
   * 이사청소의 경우에는 승인 거절시에도 인터뷰 거절 화면을 사용하기 때문에,
   * 승인 거절 날짜가 필요
   */
  const interviewNoApproveDate: string | undefined =
    serviceStatusHistoryList.find((item) => {
      if (serviceType === 'move_cleaning') {
        return item.serviceDocStatus === 'approve_reject';
      } else {
        return item.serviceDocStatus === 'interview_nonapprove';
      }
    })?.createDate;
  return (
    <Template>
      <ServiceInterviewNoApprove
        leftDueDate={
          interviewNoApproveDate
            ? moment(interviewNoApproveDate)
                .add(30, 'days')
                .format('YYYY년 MM월 DD일')
            : '-'
        }
        interviewNoApproveDate={
          interviewNoApproveDate
            ? moment(interviewNoApproveDate).format('YYYY년 MM월 DD일')
            : '-'
        }
      />
    </Template>
  );
}

export default ServiceInterviewNoApproveView;
